import { render, staticRenderFns } from "./aiSelect.vue?vue&type=template&id=33ed17ab&"
import script from "./aiSelect.vue?vue&type=script&lang=js&"
export * from "./aiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports